<template>
  <div>
    <div
      id="modal-title"
      class="modal-header"
    >
      <h2>{{ $t('delete.administrator') }}</h2>
    </div>
    <div class="modal-content">
      <div class="edit-queue">
        <form
          id="form-delete-table-1"
          action=""
        >
          <p>{{ $t('you.are.about.to.delete.admin.named') }} <strong>"{{ admin.name }}"</strong>.</p>
          <div class="form-actions">
            <button
              type="button"
              class="btn-secondary"
              @click="close"
            >
              {{ $t('cancel') }}
            </button>
            <button
              type="button"
              class="btn-warning btn-active main-action"
              @click="deleteOperator()"
            >
              {{ $t('delete') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import users from '@/api/users'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'RemoveOperator',
  props: {
    service: {
      type: String,
      required: false,
      default: null
    },
    admin: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      open: false
    }
  },
  computed: {
    ...mapState([
      'workers'
    ])
  },
  methods: {
    ...mapActions([
      'fetchUsers'
    ]),
    close () {
      this.$emit('input', false)
    },
    async deleteOperator () {
      let service = this.service
      if (this.service === '') {
        service = undefined
      }
      await users.removeUser({ service, username: this.admin.id, type: this.type })
      // Reload users in the store
      this.fetchUsers({ service: this.service, type: this.type })
      this.close()
    }
  }
}
</script>
